<template>
    <div>
        <h3>個人情報管理</h3>
        <div>
            <p>
                貸し本棚の個人情報管理方針は<router-link to="/privacy">プライバシーポリシー</router-link>に記載されています。
                この内容は一般的なものですが、規約文書であるため、
                ユーザー登録を検討する方にわかりやすい情報ではありません。
            </p>
            <h4>どこまで知られるのか</h4>
            <h5>未登録ユーザの場合</h5>
            <p>
                未登録ユーザの場合、貸し本棚は詳細なアクセスログのみを収集しています。
                これらのアクセスログは、何らかの不正なアクセスや不具合が発生したときのみ参照されるもので、
                日常的な監視には用いられることはありません。
            </p>
            <h5>登録ユーザの場合</h5>
            <p>
                登録ユーザは、管理者画面のユーザー一覧にリストされます。
                リストの内容は、
            </p>
            <ol>
                <li>ユーザ名</li>
                <li>ログイン方法</li>
                <li>許可レーティング</li>
                <li>ドメイン（登録作品数）</li>
                <li>最終アクセス時刻</li>
                <li>メールアドレスの承認状況</li>
            </ol>
            <p>
                上記に限られます。
                特に、登録ユーザの「メールアドレス」「パスワード」は、
                システム上の<b>非表示情報</b>として扱われるため、
                <b>容易に読み出すことができません</b>。
                新機能を実装したときに、誤って画面上にこれらの情報が読み込まれてしまう恐れはありません。
                また、これらの値はシステム上、ログイン、メール配信に使われるだけで、
                ご本人以外に表示されることはありません。
                管理者でさえ、これらの情報を画面上で確認することはできません。
            </p>
            <h5>管理者は小説の内容をどこまでみているのか</h5>
            <p>
                管理者は投稿された小説について、
                画面上に表示したときに崩れがないか、読みやすいか、動作に問題が無いか、
                といったシステム上の監査のために、全文を読むことがあります。
            </p>
            <p>
                管理者は、投稿小説に拍手や感想を送ることはありません。
                これは特定のユーザーに利するえこひいきを行わないための一般的な措置です。
            </p>
            <h4>何に使われるのか</h4>
            <p>
                貸し本棚に登録されたユーザー情報を、無断で第三者に提供することはありません。
                プライバシーポリシーには法令上の例外措置が記載されていますが、
                現実的に例外が発生する可能性は限りなく低いという認識です。
            </p>
            <p>
                ユーザー情報は、ログインやログアウト、小説の投稿などのシステム上必要な処理に利用され、
                これらを何らかの分析に再利用するため、外部業者に委託することはありません。
            </p>
            <h4>不正やエラーの検知</h4>
            <p>
                貸し本棚でサーバーエラーが発生した場合、
                エラーの詳細が即座に管理者へ通知されます。
                そのため、サーバ上のエラーについては、レポートしなくても、
                比較的早期に対応されます。
            </p>
            <p>
                一方、ブラウザ上でエラーが発生した場合、
                その内容については通知されません。
                管理者が気づいていない可能性がありますので、
                エラー内容をレポートしていただけると助かります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>


<script>
export default {
    created() {
        this.useHead({
            title: "個人情報管理 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>